import styled from "styled-components";

export const FullSafezoneContentDefaultBox = styled.div`
  display: flex;
  flex: 1;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0;
  }
  
  & .card {
    border:none;
  }
`;
